import flatpickr from "flatpickr";
import type Alpine from "alpinejs";

export default function flatpickrDirective(alpine: typeof Alpine) {
    alpine.directive("flatpickr", (el: HTMLInputElement, { value }, { effect, cleanup }) => {
        if (!el.id) {
            console.warn("x-flatpickr: element must have an id attribute");
            return;
        }

        const disableDaysAttr = el.getAttribute("data-disable-days");
        const minDateAttr = parseInt(el.getAttribute("data-min-date"));
        const maxDateAttr = parseInt(el.getAttribute("data-max-date"));

        // Parse disable_days from comma-separated string
        const disabledDays: number[] = [];
        if (disableDaysAttr) {
            disabledDays.push(
                ...disableDaysAttr
                    .split(",")
                    .map((day) => parseInt(day.trim(), 10))
                    .filter((day) => !Number.isNaN(day)),
            );
        }

        // Create disable function for Flatpickr
        const disableFunction =
            disabledDays.length > 0
                ? (date: Date): boolean => disabledDays.includes(date.getDay())
                : undefined;

        // Initialize Flatpickr
        const picker = flatpickr(el, {
            // minDate: minDateAttr || undefined,
            minDate: new Date().fp_incr(minDateAttr) || undefined,
            maxDate: new Date().fp_incr(maxDateAttr) || undefined,
            disable: disableFunction ? [disableFunction] : undefined,
            onChange(selectedDates) {
                if (selectedDates.length > 0) {
                    const dateObj = selectedDates[0];
                    // Format date as YYYY-MM-DD for consistency
                    const year = dateObj.getFullYear();
                    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                    const day = String(dateObj.getDate()).padStart(2, "0");
                    const formattedDate = `${year}-${month}-${day}`;

                    // Update the Alpine model
                    const fieldName = el.id;
                    const alpineData = (el as unknown as Record<string, unknown>).__x;
                    if (alpineData && typeof alpineData === "object" && "$data" in alpineData) {
                        const componentData = (alpineData as Record<string, unknown>)
                            .$data as Record<string, unknown>;
                        if (
                            componentData &&
                            typeof componentData === "object" &&
                            "form" in componentData
                        ) {
                            const form = componentData.form as Record<string, unknown>;
                            if (form && typeof form === "object") {
                                form[fieldName] = formattedDate;
                            }
                        }
                    }
                }
            },
        });

        cleanup(() => {
            picker.destroy();
        });
    });
}
